export const getView = (state) => state.views
